module.exports={"(optional)":"(isteğe bağlı)","(required)":"(gerekli)"};